var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { Checkbox as MCheckbox, FormControlLabel, } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
const useStyles = makeStyles({
    root: {
        margin: 0,
    },
});
const Checkbox = (_a) => {
    var { color = 'primary' } = _a, props = __rest(_a, ["color"]);
    const classes = useStyles();
    // for focusing purposes (key arrow navigation)
    const [action, setAction] = useState();
    return (_jsx(FormControlLabel, { classes: { root: props.noMargins ? classes.root : '' }, labelPlacement: props.labelPlacement, control: _jsx(Controller, { render: ({ onChange, value, name, ref, onBlur }) => {
                var _a;
                return (_jsx(MCheckbox, { onBlur: onBlur, name: name, indeterminate: props.indeterminate, inputRef: ref, action: setAction, onChange: (_, checked) => {
                        onChange(checked);
                        if (props.onChange) {
                            props.onChange(checked);
                        }
                    }, checked: value, color: color, 
                    // for focusing purposes (key arrow navigation)
                    onFocus: () => {
                        action === null || action === void 0 ? void 0 : action.focusVisible();
                    }, onClick: props.onClick, onKeyDown: props.onKeyDown, disabled: (_a = props.disabled) !== null && _a !== void 0 ? _a : false }));
            }, name: props.name, control: props.control, defaultValue: props.defaultValue || false }), label: props.label }));
};
export default Checkbox;
